module.exports = __webpack_public_path__ + "static/media/blog6_3.457011bc.webp";